import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('type'),
    validators.requiredString('trimBlockInput.sectionTitle.defaultValue'),
    validators.requiredBoolean('trimBlockInput.isActive'),
    validators.forEach(
        'trimBlockInput.trimSettings',
        validators.compose(
            validators.requiredString('name.defaultValue'),
            validators.requiredColorHex('hex'),
            validators.forEach('sectionImages', validators.requiredUploadFile('variantTrimImage'))
        )
    )
);

const useTrimBlockValidator = () => useValidator(validator);

export default useTrimBlockValidator;
